/* AULBERY — Reviews (design R2)
   Moved 1:1 from the inline <script> in sections/as-reviews.liquid (v16
   structural). Each section root carries data-as-reviews and
   data-section-id; the per-instance values that used to be Liquid-
   interpolated into the script are read from the
   <script type="application/json" data-as-reviews-config> block inside the
   root. The two <dialog> elements render outside the root and are matched by
   data-as-reviews-dialog="<section id>". */
(function () {
  function readConfig(root) {
    var el = root.querySelector('[data-as-reviews-config]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function initRev(root) {
    if (!root || root.dataset.asrInit === '1') return;
    root.dataset.asrInit = '1';

    var cfg = readConfig(root);
    var sectionId = root.dataset.sectionId || '';
    var cleanups = [];

    var rowsWrap = root.querySelector('[data-asr-rows]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-asr-row]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-asr-filter]'));
    var dialogs = Array.prototype.slice.call(
      document.querySelectorAll('dialog[data-as-reviews-dialog="' + sectionId + '"]')
    );
    var perPage = parseInt(cfg.perPage, 10) || 5;
    var scrollOffset = parseInt(cfg.scrollOffset, 10) || 0;
    var page = 1;
    var filter = 'all';
    var order = rows.slice();
    var pager = root.querySelector('[data-asr-pager]');

    function dialogFor(key) {
      for (var i = 0; i < dialogs.length; i++) {
        if (dialogs[i].dataset.asrModal === key) return dialogs[i];
      }
      return null;
    }

    function openDialog(dlg) {
      if (!dlg) return;
      if (typeof dlg.showModal === 'function') {
        if (!dlg.open) dlg.showModal();
      } else {
        dlg.setAttribute('open', '');
      }
    }

    function eligible() {
      return order.filter(function (r) {
        return filter !== 'photos' || r.dataset.photo === '1';
      });
    }

    function pageBtn(label, target, opts) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'asr-page-btn' + (opts && opts.on ? ' is-on' : '');
      b.textContent = label;
      if (opts && opts.disabled) b.disabled = true;
      b.addEventListener('click', function () {
        page = target;
        render(true);
      });
      return b;
    }

    function buildPager(pages) {
      if (!pager) return;
      pager.innerHTML = '';
      if (pages <= 1) return;
      pager.appendChild(pageBtn(cfg.prevText || 'Prev', Math.max(1, page - 1), { disabled: page === 1 }));
      pager.appendChild(pageBtn(cfg.nextText || 'Next', Math.min(pages, page + 1), { disabled: page === pages }));
    }

    function render(scroll) {
      var list = eligible();
      var pages = Math.max(1, Math.ceil(list.length / perPage));
      if (page > pages) page = pages;
      var start = (page - 1) * perPage;
      var end = start + perPage;

      order.forEach(function (r) { r.classList.add('is-hidden'); });
      list.slice(start, end).forEach(function (r) { r.classList.remove('is-hidden'); });

      buildPager(pages);

      var note = root.querySelector('[data-asr-disclaimer]');
      if (note) note.classList.toggle('is-hidden', page !== pages);

      if (scroll) {
        var top = root.getBoundingClientRect().top + window.pageYOffset - scrollOffset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.classList.toggle('is-on', x === c); });
        filter = c.dataset.asrFilter;
        page = 1;

        if (filter === 'recent') {
          order = rows.slice().sort(function (a, b) {
            return (parseInt(a.dataset.days, 10) || 0) - (parseInt(b.dataset.days, 10) || 0);
          });
        } else {
          order = rows.slice();
        }
        order.forEach(function (r) { rowsWrap.appendChild(r); });
        render(false);
      });
    });

    // photo lightbox
    var lightDlg = dialogFor('light');
    var lightTarget = lightDlg ? lightDlg.querySelector('[data-asr-light-target]') : null;
    root.querySelectorAll('[data-asr-light]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!lightDlg || !lightTarget) return;
        lightTarget.innerHTML = '<img src="' + btn.dataset.asrLight + '" alt="">';
        openDialog(lightDlg);
      });
    });

    // write a review
    var writeBtn = root.querySelector('[data-asr-open-write]');
    if (writeBtn) {
      writeBtn.addEventListener('click', function () {
        openDialog(dialogFor('write'));
      });
    }

    dialogs.forEach(function (dlg) {
      dlg.querySelectorAll('[data-asr-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          if (typeof dlg.close === 'function') dlg.close();
          else dlg.removeAttribute('open');
        });
      });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) {
          if (typeof dlg.close === 'function') dlg.close();
          else dlg.removeAttribute('open');
        }
      });
      var formWrap = dlg.querySelector('[data-asr-form]');
      var doneWrap = dlg.querySelector('[data-asr-done]');
      var errorEl = dlg.querySelector('[data-asr-error]');
      var picks = Array.prototype.slice.call(dlg.querySelectorAll('[data-asr-pick]'));
      var bodyEl = dlg.querySelector('textarea');
      var counter = dlg.querySelector('[data-asr-counter]');
      var fileEl = dlg.querySelector('[data-asr-file]');
      var uploadBtn = dlg.querySelector('[data-asr-upload-btn]');
      var thumbs = dlg.querySelector('[data-asr-thumbs]');
      var doneBtn = dlg.querySelector('[data-asr-done-btn]');
      var rating = 0;
      var picked = [];
      var closeTimer = null;

      function paintStars() {
        picks.forEach(function (p, i) { p.classList.toggle('is-on', i < rating); });
      }
      picks.forEach(function (p) {
        p.addEventListener('click', function () {
          rating = parseInt(p.dataset.asrPick, 10) || 0;
          paintStars();
          clearError();
        });
      });

      function clearError() {
        if (errorEl) { errorEl.textContent = ''; errorEl.classList.add('is-hidden'); }
      }
      function showError(msg) {
        if (!errorEl) return;
        errorEl.textContent = msg;
        errorEl.classList.remove('is-hidden');
      }

      var counterSep = cfg.counterSeparator == null ? ' / ' : String(cfg.counterSeparator);
      if (bodyEl && counter) {
        var max = parseInt(bodyEl.getAttribute('maxlength'), 10) || 400;
        bodyEl.addEventListener('input', function () {
          counter.textContent = bodyEl.value.length + counterSep + max;
          clearError();
        });
      }

      // Photos are previewed locally only — nothing is uploaded anywhere.
      function paintThumbs() {
        if (!thumbs) return;
        thumbs.innerHTML = '';
        picked.forEach(function (url, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'asr-thumb';
          b.setAttribute('aria-label', cfg.removeLabel || 'Remove photo');
          var img = document.createElement('img');
          img.src = url;
          img.alt = '';
          var badge = document.createElement('span');
          badge.textContent = cfg.removeGlyph == null ? 'x' : String(cfg.removeGlyph);
          b.appendChild(img);
          b.appendChild(badge);
          b.addEventListener('click', function () {
            URL.revokeObjectURL(picked[i]);
            picked.splice(i, 1);
            paintThumbs();
          });
          thumbs.appendChild(b);
        });
      }
      if (uploadBtn && fileEl) {
        uploadBtn.addEventListener('click', function () { fileEl.click(); });
        fileEl.addEventListener('change', function () {
          var maxPhotos = parseInt(cfg.maxPhotos, 10) || 3;
          var files = Array.prototype.slice.call(fileEl.files || []);
          files.forEach(function (f) {
            if (picked.length >= maxPhotos) return;
            picked.push(URL.createObjectURL(f));
          });
          fileEl.value = '';
          paintThumbs();
        });
      }

      function resetForm() {
        if (!formWrap || !doneWrap) return;
        picked.forEach(function (u) { URL.revokeObjectURL(u); });
        picked = [];
        rating = 0;
        paintStars();
        paintThumbs();
        if (bodyEl) bodyEl.value = '';
        if (counter && bodyEl) counter.textContent = '0' + counterSep + (bodyEl.getAttribute('maxlength') || '400');
        dlg.querySelectorAll('input[type="text"], input[type="email"]').forEach(function (i) { i.value = ''; });
        clearError();
        formWrap.classList.remove('is-hidden');
        doneWrap.classList.add('is-hidden');
      }

      var submit = dlg.querySelector('[data-asr-submit]');
      if (submit) {
        submit.addEventListener('click', function () {
          if (cfg.requireRating !== false) {
            if (rating === 0) { showError(cfg.errorRating || 'Pick a star rating first.'); return; }
          }
          if (cfg.requireBody !== false) {
            if (bodyEl && !bodyEl.value.trim()) { showError(cfg.errorBody || 'Write a few words about the product.'); return; }
          }
          if (!formWrap || !doneWrap) return;
          formWrap.classList.add('is-hidden');
          doneWrap.classList.remove('is-hidden');
          var auto = parseInt(cfg.autoClose, 10) || 0;
          if (auto > 0) {
            clearTimeout(closeTimer);
            closeTimer = setTimeout(function () {
              if (typeof dlg.close === 'function') dlg.close();
              else dlg.removeAttribute('open');
            }, auto * 1000);
          }
        });
      }
      if (doneBtn) {
        doneBtn.addEventListener('click', function () {
          if (typeof dlg.close === 'function') dlg.close();
          else dlg.removeAttribute('open');
        });
      }
      dlg.addEventListener('close', function () {
        clearTimeout(closeTimer);
        resetForm();
      });

      cleanups.push(function () {
        clearTimeout(closeTimer);
        picked.forEach(function (u) { URL.revokeObjectURL(u); });
        picked = [];
      });
    });

    root.asReviewsCleanup = function () {
      cleanups.forEach(function (fn) { fn(); });
      cleanups = [];
      root.dataset.asrInit = '';
    };

    render(false);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-as-reviews]'), initRev);
  }

  function onUnload(e) {
    var scope = e && e.target && e.target.querySelectorAll ? e.target : null;
    if (!scope) return;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-as-reviews]'), function (root) {
      if (typeof root.asReviewsCleanup === 'function') root.asReviewsCleanup();
    });
  }

  // the asset is loaded once per section instance; bind the document
  // listeners only the first time it runs
  if (document.documentElement.dataset.asReviewsBound !== '1') {
    document.documentElement.dataset.asReviewsBound = '1';
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:unload', onUnload);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

